import { defineStore } from 'pinia';
import { getInitialEntityState } from '@/store/common/entities-state';
import { createEntityActions } from '@/store/common/entities-actions';
import { Collection } from '@/store/common/collections';
import { createEntityGetters } from '@/store/common/entities-getters';
import { MachineModel } from '@/model/machine-model';
import { InputOption } from '@/model/input-option';
import { useMachinesStore } from '@/store/machines-store';
import { reactive } from 'vue';

function sortByName(a: MachineModel, b: MachineModel): number {
  return a.name.localeCompare(b.name);
}

const initialEntityState = reactive({
  ...getInitialEntityState<MachineModel>(sortByName),
});

export const useMachineModelsStore = defineStore('machineModels', {
  state: () => initialEntityState,
  getters: {
    ...createEntityGetters<MachineModel>(),
    getSortedByName(state): MachineModel[] {
      return [...state.entities].sort(sortByName);
    },
    getAsSelectOptions(): InputOption[] {
      return this.getSortedByName.map((machineModel: MachineModel) => {
        return {
          value: machineModel.id + '',
          label: machineModel.name,
        };
      });
    },
  },
  actions: {
    ...createEntityActions<MachineModel>(
      Collection.MACHINE_MODELS,
      initialEntityState,
    ),
    verifyConfiguration() {
      useMachinesStore().verifyConfiguration();
    },
  },
});
